import { render } from "./ChipFilters.vue?vue&type=template&id=263ff5a9&ts=true"
import script from "./ChipFilters.vue?vue&type=script&lang=ts"
export * from "./ChipFilters.vue?vue&type=script&lang=ts"

import "./ChipFilters.vue?vue&type=style&index=0&id=263ff5a9&lang=scss"

import exportComponent from "/builds/likeacoffee.com/time-assistantv3-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__